import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ToggleGroup, ToggleGroupItem } from '../ui/toggle-group';

// Build selectable 15-min slots for today from the opening-window list returned
// by the backend, disabling those earlier than now + lead time (local clock).
export const useTimeSlots = (cfg) => useMemo(() => {
  const slots = cfg?.slots || [];
  const lead = cfg?.lead_minutes ?? 30;
  const now = new Date();
  const minMin = now.getHours() * 60 + now.getMinutes() + lead;
  const usable = slots.filter((s) => {
    const [h, m] = s.split(':').map(Number);
    return h * 60 + m >= minMin;
  });
  const groups = {};
  usable.forEach((s) => {
    const hour = s.split(':')[0];
    (groups[hour] = groups[hour] || []).push(s);
  });
  return { usable, groups };
}, [cfg]);

export const TimeSlotPicker = ({ cfg, value, onChange, testId = 'delivery-time-slot-group' }) => {
  const { t } = useTranslation();
  const { groups, usable } = useTimeSlots(cfg);
  return (
    <div data-testid={testId}>
      <ToggleGroup type="single" value={value} onValueChange={(v) => v && onChange(v)} className="flex-wrap justify-start gap-2">
        <ToggleGroupItem
          value="asap"
          data-testid="time-slot-asap"
          className="h-9 px-3 rounded-full border data-[state=on]:bg-primary data-[state=on]:text-primary-foreground data-[state=on]:border-primary"
        >
          {t('offsite.asap')}
        </ToggleGroupItem>
      </ToggleGroup>
      {usable.length === 0 ? (
        <p className="mt-2 text-xs text-muted-foreground">{t('offsite.noSlots')}</p>
      ) : (
        <div className="mt-3 space-y-3 max-h-44 overflow-auto pr-1">
          {Object.entries(groups).map(([hour, list]) => (
            <div key={hour}>
              <div className="text-xs font-medium text-muted-foreground uppercase tracking-wide mb-1.5">{hour}:00</div>
              <ToggleGroup type="single" value={value} onValueChange={(v) => v && onChange(v)} className="flex-wrap justify-start gap-2">
                {list.map((s) => (
                  <ToggleGroupItem
                    key={s}
                    value={s}
                    data-testid={`time-slot-${s}`}
                    className="h-9 px-3 rounded-full border tabular text-sm data-[state=on]:bg-primary data-[state=on]:text-primary-foreground data-[state=on]:border-primary"
                  >
                    {s}
                  </ToggleGroupItem>
                ))}
              </ToggleGroup>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
